import { render } from "./WhatsAppConnectionsPerAgencyStatistics.vue?vue&type=template&id=61c6896b&scoped=true"
import script from "./WhatsAppConnectionsPerAgencyStatistics.vue?vue&type=script&lang=js"
export * from "./WhatsAppConnectionsPerAgencyStatistics.vue?vue&type=script&lang=js"

import "./WhatsAppConnectionsPerAgencyStatistics.vue?vue&type=style&index=0&id=61c6896b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c6896b"]])

export default __exports__